// extracted by mini-css-extract-plugin
export default {"newsContainer":"Entry_newsContainer__4r6vs","entryContainer":"Entry_entryContainer__egjic"};